export default {
    topics: [
        {
            title: ' Button ',
            href: 'control-Button.html',
            attributes: { 'data-id': 'control-Button' },
            menu: { hasChildren: false },
            tocID: 'control-Button-d66e7867',
            topics: [],
        },
        {
            title: ' CheckBox ',
            href: 'control-CheckBox.html',
            attributes: { 'data-id': 'control-CheckBox' },
            menu: { hasChildren: false },
            tocID: 'control-CheckBox-d66e7875',
            topics: [],
        },
        {
            title: ' CodeEdit ',
            href: 'control-CodeEdit.html',
            attributes: { 'data-id': 'control-CodeEdit' },
            menu: { hasChildren: false },
            tocID: 'control-CodeEdit-d66e7883',
            topics: [],
        },
        {
            title: ' Date ',
            href: 'control-Date.html',
            attributes: { 'data-id': 'control-Date' },
            menu: { hasChildren: false },
            tocID: 'control-Date-d66e7891',
            topics: [],
        },
        {
            title: ' DateTime ',
            href: 'control-DateTime.html',
            attributes: { 'data-id': 'control-DateTime' },
            menu: { hasChildren: false },
            tocID: 'control-DateTime-d66e7899',
            topics: [],
        },
        {
            title: ' Edit ',
            href: 'control-Edit.html',
            attributes: { 'data-id': 'control-Edit' },
            menu: { hasChildren: false },
            tocID: 'control-Edit-d66e7907',
            topics: [],
        },
        {
            title: ' Enum ',
            href: 'control-Enum.html',
            attributes: { 'data-id': 'control-Enum' },
            menu: { hasChildren: false },
            tocID: 'control-Enum-d66e7915',
            topics: [],
        },
        {
            title: ' FileEdit ',
            href: 'control-FileEdit.html',
            attributes: { 'data-id': 'control-FileEdit' },
            menu: { hasChildren: false },
            tocID: 'control-FileEdit-d66e7923',
            topics: [],
        },
        {
            title: ' Label ',
            href: 'control-Label.html',
            attributes: { 'data-id': 'control-Label' },
            menu: { hasChildren: false },
            tocID: 'control-Label-d66e7931',
            topics: [],
        },
        {
            title: ' LinkEdit ',
            href: 'control-LinkEdit.html',
            attributes: { 'data-id': 'control-LinkEdit' },
            menu: { hasChildren: false },
            tocID: 'control-LinkEdit-d66e7939',
            topics: [],
        },
        {
            title: ' LinkList ',
            href: 'control-LinkList.html',
            attributes: { 'data-id': 'control-LinkList' },
            menu: { hasChildren: false },
            tocID: 'control-LinkList-d66e7947',
            topics: [],
        },
        {
            title: ' LinkListChoice ',
            href: 'control-LinkListChoice.html',
            attributes: { 'data-id': 'control-LinkListChoice' },
            menu: { hasChildren: false },
            tocID: 'control-LinkListChoice-d66e7956',
            topics: [],
        },
        {
            title: ' Number ',
            href: 'control-Number.html',
            attributes: { 'data-id': 'control-Number' },
            menu: { hasChildren: false },
            tocID: 'control-Number-d66e7964',
            topics: [],
        },
        {
            title: ' PathEdit ',
            href: 'control-PathEdit.html',
            attributes: { 'data-id': 'control-PathEdit' },
            menu: { hasChildren: false },
            tocID: 'control-PathEdit-d66e7972',
            topics: [],
        },
        {
            title: ' RadioButton ',
            href: 'control-RadioButton.html',
            attributes: { 'data-id': 'control-RadioButton' },
            menu: { hasChildren: false },
            tocID: 'control-RadioButton-d66e7980',
            topics: [],
        },
        {
            title: ' SubFormButton ',
            href: 'control-SubFormButton.html',
            attributes: { 'data-id': 'control-SubFormButton' },
            menu: { hasChildren: false },
            tocID: 'control-SubFormButton-d66e7988',
            topics: [],
        },
        {
            title: ' SubFormLink ',
            href: 'control-SubFormLink.html',
            attributes: { 'data-id': 'control-SubFormLink' },
            menu: { hasChildren: false },
            tocID: 'control-SubFormLink-d66e7996',
            topics: [],
        },
        {
            title: ' SysEnum ',
            href: 'control-SysEnum.html',
            attributes: { 'data-id': 'control-SysEnum' },
            menu: { hasChildren: false },
            tocID: 'control-SysEnum-d66e8004',
            topics: [],
        },
        {
            title: ' Time ',
            href: 'control-Time.html',
            attributes: { 'data-id': 'control-Time' },
            menu: { hasChildren: false },
            tocID: 'control-Time-d66e8012',
            topics: [],
        },
        {
            title: ' UrlButton ',
            href: 'control-UrlButton.html',
            attributes: { 'data-id': 'control-UrlButton' },
            menu: { hasChildren: false },
            tocID: 'control-UrlButton-d66e8020',
            topics: [],
        },
        {
            title: ' Value ',
            href: 'control-Value.html',
            attributes: { 'data-id': 'control-Value' },
            menu: { hasChildren: false },
            tocID: 'control-Value-d66e8028',
            topics: [],
        },
    ],
};

